var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2200,
    height: 450,
    viewBox: "0 0 2200 450",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "translate(-507.11962,-1078.9996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11",
    transform: "matrix(0.41502657,0,0,0.41502657,547.572,750.63127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 0,0 -119,-204 336,124 c 54,21 70,27 87,92 l 37,135 -576,-48 c -57,-5 -67,-13 -83,-39 z",
    fill: "#f44b4b",
    transform: "matrix(1.3333333,0,0,-1.3333333,424,1392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M 0,0 -177,33 -296,-171 40,-47 c 21,8 23,30 -40,47",
    fill: "#ad4a52",
    transform: "matrix(1.3333333,0,0,-1.3333333,660,1436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 0,0 204,-40 c 51,-9 130,-27 156,-67 l -235,-19 c -18,0 -26,6 -41,25 z",
    fill: "#ff7f7f",
    transform: "matrix(1.3333333,0,0,-1.3333333,241.33333,1002.6667)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 0,0 c 18,0 30,-12 31,-31 h -64 c 2,17 14,31 33,31 m 0,13 c -29,0 -49,-22 -49,-50 0,-28 20,-50 50,-50 20,0 37,10 43,26 H 26 c -4,-8 -13,-12 -25,-12 -20,0 -32,14 -34,31 H 47 C 50,-10 30,13 0,13 m -65,-82 c -5,-2 -11,-4 -16,-4 -14,0 -21,7 -21,24 v 46 h 36 v 14 h -36 v 35 h -15 V 11 h -25 V -3 h 25 v -46 c 0,-25 11,-38 34,-38 6,0 13,1 21,3 z m -113,-16 h 16 v 96 h -16 z m 8,121 c 6,0 11,5 11,11 0,5 -5,10 -11,10 -6,0 -11,-5 -11,-10 0,-6 5,-11 11,-11 m -60,-121 h 16 V 61 h -16 z m -26,16 c -6,-2 -12,-4 -17,-4 -14,0 -20,7 -20,24 v 46 h 35 v 14 h -35 v 35 h -16 V 11 h -25 V -3 h 25 v -46 c 0,-25 11,-38 35,-38 5,0 12,1 20,3 z M -401,58 c -30,0 -50,-16 -50,-40 0,-20 12,-32 37,-37 l 26,-5 c 18,-3 25,-12 25,-23 0,-16 -13,-26 -35,-26 -24,0 -39,12 -43,33 h -16 c 3,-30 25,-47 59,-47 31,0 52,16 52,42 0,20 -14,32 -39,37 l -23,4 c -17,3 -26,10 -26,23 0,15 14,25 34,25 23,0 35,-11 38,-27 h 16 c -3,28 -27,41 -55,41",
    fill: "#ffffff",
    transform: "matrix(1.3333333,0,0,-1.3333333,1580,1286.6667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 0,0 c -15,0 -26,12 -26,24 0,15 11,26 26,26 9,0 18,-3 24,-13 V 12 C 18,3 9,0 0,0 m 24,70 v -5 c -8,5 -17,8 -28,8 -27,0 -49,-20 -49,-49 0,-26 22,-48 49,-48 11,0 20,3 28,8 v -12 c 0,-16 -10,-25 -23,-25 -14,0 -23,7 -24,18 h -27 c 2,-25 23,-42 51,-42 29,0 50,18 50,49 v 98 z m -137,3 c -11,0 -21,-4 -29,-10 v 7 h -27 v -98 h 27 v 64 c 7,8 16,12 23,12 14,0 22,-8 22,-24 v -52 h 27 v 54 c 0,28 -17,47 -43,47 M -224,-28 h 27 v 98 h -27 z m 13,118 c 9,0 17,6 17,15 0,10 -8,16 -17,16 -9,0 -16,-6 -16,-16 0,-9 7,-15 16,-15 m -70,-31 v 11 h -27 v -98 h 27 v 60 c 8,9 19,14 35,15 v 25 c -15,0 -26,-4 -35,-13 M -385,-6 c -15,0 -26,13 -26,27 0,15 11,27 26,27 9,0 18,-2 24,-11 V 6 c -6,-9 -15,-12 -24,-12 m 24,76 v -5 c -8,5 -17,8 -28,8 -27,0 -49,-23 -49,-52 0,-28 22,-51 49,-51 11,0 20,3 28,8 v -6 h 27 v 98 z m -140,3 c -11,0 -21,-4 -29,-10 v 55 h -26 V -28 h 26 v 64 c 7,8 16,12 23,12 14,0 22,-8 22,-24 v -52 h 27 v 54 c 0,28 -17,47 -43,47 m -135,42 c -32,0 -53,-18 -53,-44 0,-22 12,-36 40,-41 l 22,-5 c 15,-2 19,-9 19,-15 0,-10 -9,-15 -25,-15 -19,0 -32,9 -34,23 h -28 c 2,-30 26,-48 61,-48 33,0 54,17 54,44 0,23 -15,33 -42,39 l -17,3 c -13,3 -21,7 -21,17 0,12 10,18 26,18 17,0 26,-8 28,-21 h 27 c -3,35 -34,45 -57,45",
    fill: "#f44b4b",
    transform: "matrix(1.3333333,0,0,-1.3333333,2598.6667,1362.6667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.4f8036b8528dde6c7ec305125907c8fb.svg";
export { ForwardRef as ReactComponent };